module.exports = __webpack_public_path__ + "img/L9S.18f10464.png";